var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBento9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5h2v2H7v-2zm-4.5 0h2v2h-2v-2zm9 0h2v2h-2v-2zM7 7h2v2H7V7zM2.5 7h2v2h-2V7zm9 0h2v2h-2V7zM7 11.5h2v2H7v-2zm-4.5 0h2v2h-2v-2zm9 0h2v2h-2v-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBento9);
export default __webpack_public_path__ + "static/media/bento-9.fd6769038c6159308aebdd51225745f7.svg";
export { ForwardRef as ReactComponent };